
import PropTypes from 'prop-types';
import { Stack, Chip, Box, Tooltip } from '@mui/material';
import { useState } from 'react';
import { CustomAvatar } from '../../../../../../reusable-components/custom-avatar';

UserList.propTypes = {
  users: PropTypes.array,
  removeUser: PropTypes.func,
}

export default function UserList({users, removeUser }) {
  const [showMoreTooltip, setShowMoreTooltip] = useState(false);
  return users?.slice(0, 4).map((u, index) => <Stack direction="row" alignItems="center" key={u.id}>
    <Chip
      key={u.id}
      label={u.value || u?.id}
      onDelete={() => users.length > 1 && removeUser(u.id)}
      avatar={
        <CustomAvatar
          name={u?.value || u?.id}
          email={u?.email || u?.id || u?.value}
          index={index}
          key={index}
          sx={{ '&.MuiChip-avatar': { color: '#fff !important' } }}
        />
      }
      sx={{ mr: 1, mb: 1, maxWidth: '180px' }}
    />
    {users.length > 4 && index === 3 && (
    <Tooltip
      open={showMoreTooltip}
      onClose={() => setShowMoreTooltip(false)}
      title={
        <Box>
          {users.slice(4).map((user) => (
            <div key={user.id || user}>{user.value || user}</div>
          ))}
        </Box>
      }
    >
      <Chip
        label={`+${users.length - 4}`}
        sx={{ mr: 1, mb: 1, maxWidth: '180px', cursor: 'pointer ' }}
        onClick={() => setShowMoreTooltip(true)}
      />
    </Tooltip>)}
  </Stack>)
}